import { NgClass, NgStyle } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [NgStyle,NgClass],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input() text: string = 'Click Me'; // Default button text
  @Input() type: string = 'button'; // Button type (submit, reset, button)
  @Input() disabled: boolean = false; // Disabled state
  @Input() customClass: string = ''; // Custom class for styling
  @Input() customStyle: { [key: string]: string } = {}; // Dynamic inline styles
  @Input() state: 'default' | 'correct' | 'incorrect' = 'default'; // State for animations
  @Input() isDefault?:boolean = true;
  @Input() useLowPadding:boolean = false;
  @Output() onClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>(); // Button click output event


  private resetTimeout: any;

  handleClick(event: MouseEvent): void {
    if (!this.disabled) {
      this.onClick.emit(event);
    }
  }

  setState(newState: 'default' | 'correct' | 'incorrect', duration: number = 2000): void {
    this.state = newState;
    if (newState !== 'default') {
      // Reset state to default after the specified duration
      clearTimeout(this.resetTimeout);
      this.resetTimeout = setTimeout(() => {
        this.state = 'default';
      }, duration);
    }
  }
}
